import { render, staticRenderFns } from "./MobileMain.vue?vue&type=template&id=6b086f29&scoped=true&"
import script from "./MobileMain.vue?vue&type=script&lang=js&"
export * from "./MobileMain.vue?vue&type=script&lang=js&"
import style0 from "./MobileMain.vue?vue&type=style&index=0&id=6b086f29&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b086f29",
  null
  
)

export default component.exports